module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/jiantou-hover-21c83aa9650c36acbc794fd52a831c4d.gif";